import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const ERToTable = () => (
  <QPhototModuleSubtopic
    title="ER to Table"
    videos={[
      "https://www.youtube.com/embed/v3qGAu88ifI",
      "https://www.youtube.com/embed/aLtGpNI5n9c"
    ]}
    takeaways={[]}
    questions={[
      { text: "Depict the given ER model to relational schema by following appropriate mapping steps.",
        image:"/dbms_11.png"
       },
      { text: "Map the following ER Diagram to a relational model. Identify the relationship and map the cardinality. Represent primary key and foreign key in the schema.",
        image:"/dbms_12.png"
       },
      { text: "Convert the following ER to Relational Model.",
        image:"/dbms_13.png"
       },
      { text: "Map the given ER Model to a relational schema. Identify and represent all the constraints.",
        image:"/dbms_14.png"
       }
    ]}
    exampleVideos={[]}
  />
);

export default ERToTable;
